import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Reconocer tu verdadero valor.', 'Dejar de buscar validación externa.', 'Aprender a poner límites sanos.', 'Soltar relaciones que ya no te aportan.', 'Fortalecer tu autoestima.', 'Recuperar tu confianza.', 'Convertirte en una mujer que ya no acepta migajas.'];
  return <section className="w-full bg-white py-16 md:py-24 px-4 border-t-2 border-dashed border-gray-200" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-center text-gray-900 mb-12 leading-tight" data-id="element-18">
          Después de leer este libro podrás:
        </h2>

        <div className="bg-brand-cream border-2 border-brand-gold/30 rounded-2xl p-8 md:p-12 shadow-lg relative overflow-hidden" data-id="element-19">
          {/* Decorative element */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-bl-full -mr-4 -mt-4" data-id="element-20"></div>

          <div className="relative z-10 space-y-6" data-id="element-21">
            {benefits.map((item, i) => <div key={i} className="flex items-center gap-4 bg-white p-4 rounded-xl shadow-sm" data-id="element-22">
                <CheckCircle2 className="w-6 h-6 text-brand-gold flex-shrink-0" data-id="element-23" />
                <span className="text-lg md:text-xl text-gray-800 font-bold" data-id="element-24">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}